/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import { createCashReceiptsCancelIssue } from '../../../apis/cash-receipts'
import Form from '../../../components/Form'
import Modal, { ModalHeader } from '../../../components/Modal'
import { CSHPT_CNCL_RSN_CD } from '../../../constants/CASH_INVOICE'
import useForm from '../../../hooks/useForm'
import { viewLoading } from '../../../utils/loading'
import systemAlert from '../../../utils/systemAlert'

const CashInvoiceCancelIssue = ({ open, setOpen, submit, data }) => {
  const [fields] = useState([
    [
      {
        title: "취소사유",
        key: "cshptCnclRsnCd",
        type: 'select',
        options: {
          list: CSHPT_CNCL_RSN_CD
        },
        required: true,
      },
    ],
  ]);

  useEffect(() => {
    setValidateFields(fields)
  }, [open])

  const _submit = (form) => {
    systemAlert('현금영수증을 취소 발행하시겠습니까?', {
      buttons: [
        {
          color: 'text',
          label: '취소'
        },
        {
          label: '확인',
          onClick: () => {
            viewLoading(true)
            createCashReceiptsCancelIssue(form).then(() => {
              cancel();
              if (submit) {
                submit()
              }
            })
              .catch(() => { })
              .finally(() => { viewLoading(false) })
          }
        }
      ]
    })
  }

  const {
    form,
    setForm,
    errors,
    handleOnChange,
    handleSubmit,
    setValidateFields,
  } = useForm(
    {
      trsDtStrt: data.trDt,
      trsDtEnd: data.trDt,
      s_aprvNo: data.apprNo,
      totaTrsAmt: String(data.totAmt),
      cshptCnclRsnCd: "1"
    },
    _submit,
  );

  const cancel = () => {
    setOpen(false)
  }

  return (
    <>
      <Modal isOpen={open} close={cancel} size="sm">
        <div className="cash-invoice-write">
          <ModalHeader>
            현금영수증 취소 발행
          </ModalHeader>
          <Form
            form={form}
            errors={errors}
            isRequiredShow={true}
            setForm={setForm}
            fields={fields}
            onChange={handleOnChange}
            submitText={'취소발행'}
            submit={handleSubmit}
            cancel={cancel}
          />
        </div>
      </Modal>
    </>
  )
}

export default CashInvoiceCancelIssue